import React,{useState,useEffect} from "react"
import {Modal,ModalFooter,ModalHeader,ModalBody} from "reactstrap" 
import _ from "lodash"
import { useGlobal } from "./Reducer";
import Api from "./Api";

export default (props)=>{
    
    const [options,setOptions]=useState(["",""]);
    const [globalState,globalActions]=useGlobal();
    const [question,setQuestion]=useState(props.poll?props.poll.title:"");


    useEffect(()=>{
        if(props.poll)
        {
            globalActions.loading(true);
            Api.getPollOptions(props.poll.id).then(({options})=>{
                setOptions(_.map(options,a=>a.title));
            }).catch(err=>{
              
            }).finally(()=>{
                globalActions.loading(false);
            })
        }

    },[])


    const addOption=()=>{
        setOptions([...options,""]);
    }

    const savePoll=()=>
    {
        if(question.trim().length==0)
        {
            globalActions.showAlert("Empty question","Poll question is empty!");
            return;
        }
        if(options.length==0)
        {
            globalActions.showAlert("Empty items","Poll items is empty!");
            return;
        }
        globalActions.loading(true);
        Api.savePoll(question,options,props.poll?props.poll.id:'NEW').then(()=>{
            props.onClose();
        }).catch(err=>{
 
       
        }).finally(e=>{
            globalActions.loading(false);
        })


    

    }

    const removeOption=(index)=>{
        const newOptions=[...options];
        _.remove(newOptions,(a,i)=>i==index);
        setOptions(newOptions);
    }

    return (<Modal centered={true} isOpen={true} size="xl">
        <ModalHeader>Poll Editor</ModalHeader>
        <ModalBody>
            <div>
                <div className="form-group">
                    <label>Poll Question</label>
                    <textarea value={question} onChange={e=>{
                        setQuestion(e.target.value)
                    }} className="form-control textarea"></textarea>
                </div>
                <div>
                    <label>Options</label>
                    <div>
                        {_.map(options,(option,index)=>{
                
                            return (<div key={index+"row"} className="row">
                                    <div className="col-1">Option {index+1}</div>
                                    <div  className="col-10 form-group"><input
                                    value={options[index]}
                                        onChange={(e)=>{
                                            options[index]=e.target.value
                                            setOptions([...options]);
                                        }}
                                    type="text" className="form-control"/></div>
                                    <div className="col-1"><button 
                                    onClick={()=>{
                                        removeOption(index);
                                    }} className="btn btn-sm btn-danger">remove</button></div>
                            </div>);
                        })}
                    </div>
                    <button onClick={addOption} className="btn btn-sm btn-info">Add Option</button>
                </div>
            </div>

        </ModalBody>
         <ModalFooter>
                <button onClick={savePoll} className="btn btn-success">Save</button> 
                <button onClick={props.onClose} className="btn btn-secondary">Cancel</button> 
            </ModalFooter>   
    </Modal>);
}
